/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2023.09.05.
 * @Author
 * @Description 恪保 - store 文件 .
 **/
import { defineStore } from 'pinia'
/**
 *@Description 定义 jsapi 方法 .
 * ref() 成为state属性
 * computed() - getters
 * function() - actions
 *@Return  .
 **/
export const useToolStore = defineStore('initTool', {
  state: () => {
    return {
      backTop: false,
      useLoading: false,
      useCollapse: false, // true：折叠、false：展开
      useCurrentRoute: '', // 当前路由 - 高亮使用
    }
  },
  getters: {
    getBackTop(): boolean {
      return this.backTop
    },
  },
  actions: {
    /**
     *@Description 页面 load ing .
     *@Return  .
     **/
    setLoading(val: boolean) {
      this.useLoading = val
    },
    /**
     *@Description 高亮 - 当前路由 .
     *@Return .
     */
    setCurrentRoute(val: string) {
      this.useCurrentRoute = val
    },
    /**
     *@Description 侧边栏 折叠 .
     *@Return true：折叠、false：展开 .
     **/
    setCollapse(val: boolean) {
      this.useCollapse = val
    },
    setBackTop(value: boolean) {
      this.backTop = value
    },
  },
})
